import { React, useContext, useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import { Container } from "../components/utils";
import { PhrasesContext } from "../context/phrasesContext";
import Nav from "../layouts/Nav";
import FooterLayout from "./FooterLayout";
const ThemeLayout = ({ children, navbarRef, isRequest }) => {
  const [lang, setLang] = useState("");

  const [enPhrase, arPhrase] = useContext(PhrasesContext);

  useEffect(() => {
    const lang = window.localStorage.getItem("lang");

    if (lang === "en") {
      document.body.dir = "ltr";
      setLang("en");
    } else {
      document.body.dir = "rtl";
      setLang("ar");
    }
  }, []);

  const changeLanguage2 = (lang) => {
    if (lang === "en") {
      document.body.dir = "rtl";
      setLang("ar");
      window.localStorage.setItem("lang", "ar");
    } else {
      document.body.dir = "ltr";
      setLang("en");
      window.localStorage.setItem("lang", "en");
    }
    window.location.reload();
  };

  return (
    <div className="w-full h-full">
      <Nav
        navbarRef={navbarRef}
        lang={lang}
        enPhrase={enPhrase}
        arPhrase={arPhrase}
        changeLanguage2={changeLanguage2}
        hideUpload={true}
      />
      <section
        id="overflow"
        className="w-full  bg-gold-10 border-t border-b wow fadeInUp pt-[0rem] xl:pt-[0rem] bg-LogoEJECommon bg-no-repeat bg-center-left min-h-[764px] md:min-h-screen xl:min-h-[calc(100vh-65px)]"
      >
        {/* <div className="bg-white absolute top-0 left-0 h-18 w-full"> </div> */}
        <Container>
          <div
            className={`flex flex-col ${
              !isRequest ? "gap-10" : "px-[60px]"
            } items-center justify-center `}
          >
            {children}
          </div>
        </Container>
      </section>
      {!isRequest && (
        <FooterLayout lang={lang} enPhrase={enPhrase} arPhrase={arPhrase} />
      )}
    </div>
  );
};

export default ThemeLayout;
